import React, { FC, useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table } from '@ru-digital-assets/ui-component';
import PageHeader from '../../../modules/page-header';
import { IExchange } from '../../../services/api/dto/shared';
import { useAppDispatch } from '../../../store';
import { getExchanges } from '../../../store/actions/exchange';
import { RootState, SORT_DIRECTION } from '../../../types';
import COLUMNS from './columns';
import Filters from './filters';
import RowComponent from './row-component';

const Exchanges: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [selectValue] = useState<string>('public');
  const [direction, setDirection] = useState<SORT_DIRECTION>('ASC');
  const [search, setSearch] = useState<string>('');
  const [period, setPeriod] = useState<{ from?: string; to?: string }>();
  const data: IExchange[] = useSelector((s: RootState) => s.exchange.exchanges);
  const types = useSelector((s: RootState) => s.commonInfo.paymentTypes);

  useEffect(() => {
    dispatch(getExchanges({}));
  }, []);

  useEffect(() => {
    dispatch(
      getExchanges({
        search,
        period: {
          ...period,
          direction,
        },
        isPublic: selectValue === 'public',
      })
    );
  }, [direction, period, search, selectValue]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <PageHeader
            items={[{ link: '', title: 'Обмен' }]}
            iconType="exchange"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <Filters setSearch={setSearch} setPeriod={setPeriod} />
          <Table
            count={8}
            columns={COLUMNS(
              (dir) => setDirection(direction === 'ASC' ? 'DESC' : 'ASC'),
              direction,
              types
            )}
            RowComponent={RowComponent}
            onRowClick={(id: string) =>
              history.push(`/exchange-info/${id}`, { id })
            }
            data={data}
          />
        </div>
      </div>
    </div>
  );
};

export default Exchanges;
